import React from 'react';

import FormComponent  from '../FormComponent.jsx';
import style from './user.comments.less';
import { compareObjectsInclusive } from '../../../common/utils.jsx';
import { EMPTY_STRING } from '../../questionnaire.utils.jsx';

export default class UserComments extends FormComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.state = {
      value: this.props.value || EMPTY_STRING,
    };
  }

    shouldComponentUpdate(nextProps, nextState) {
        const stateIsChanged = this.state.value !== nextState.value;
        return compareObjectsInclusive(this.props, nextProps, [ 'value', 'disabled', 'name', 'id' ]) || stateIsChanged;
    }
    onBlur() {
        const value = this.state.value;
        this.onChangeHandler(value);
    }
    onChange(event) {
        const value = event.target.value;
        this.setState({ value });
    }
    render() {
        const { id, name, placeholder, disabled } = this.props;
        const value = this.state.value;
        return (<div>
            <textarea
                disabled    =   {disabled}
                id          =   {id}
                name        =   {name}
                maxLength   =   "2000"
                value       =   {value}
                onBlur      =   {this.onBlur}
                onChange    =   {this.onChange}
                placeholder =   {placeholder}
                className   =   {style.textArea}
            />
        </div>);
    }
}
